import { useBlockProps } from "@wordpress/block-editor";
const Save = (props) => {
	return <div>myaccount</div>;
};

export default Save;
